import { useEffect, useState } from "react";
import api from "../lib/api";

/** useTestimonials — one-shot fetch of published testimonials */
export function useTestimonials() {
  const [testimonials, setTestimonials] = useState([]);
  useEffect(() => {
    api.get("/testimonials")
      .then((r) => setTestimonials(r.data))
      .catch(() => { /* silent — Home page still renders without testimonials */ });
  }, []);
  return testimonials;
}
